import { UnfoldIcon } from 'components/icons'
import classNames from 'helpers/class-names'
import { ChangeEvent, Dispatch, FC, ReactNode, Ref } from 'react'
import { ComboboxOption, ComboboxOptions } from 'ui'

interface Props {
  setSelected: Dispatch<any>
  selected?: ComboboxOption
  options: ComboboxOptions
  label?: string | ReactNode
  id: string
  className?: string
  name: string
  optionValue?: (option: ComboboxOption) => string
  selectRef: Ref<any>
  onFocus?: any
  onBlur?: any
}

const Select: FC<Props> = ({
  id,
  setSelected,
  selected,
  options,
  label,
  className,
  name,
  optionValue,
  selectRef,
  onFocus,
  onBlur,
}) => {
  const handleChange = (
    event: ChangeEvent<HTMLSelectElement>,
    options: ComboboxOptions,
  ) => {
    options.map((option) => {
      if ('name' in option) {
        handleChange(event, option.options)
      } else {
        if (String(option.id) === String(event.target.value)) {
          setSelected(option)
        }
      }
    })
  }

  return (
    <div className={classNames('text-base', { 'mt-1': label })}>
      {label !== null && (
        <label
          htmlFor={id}
          className="text-xs font-bold uppercase text-gray-400 dark:text-gray-200">
          {label}
        </label>
      )}
      <div className="relative">
        <select
          className={`${className} appearance-none dark:text-gray-50`}
          id={id}
          ref={selectRef}
          name={name}
          value={selected?.id || ''}
          onChange={(event) => handleChange(event, options)}
          onFocus={onFocus}
          onBlur={onBlur}>
          {options.map((option) =>
            'name' in option ? (
              <optgroup key={option.name} label={option.name}>
                {option.options.map((groupOption) => (
                  <option
                    key={`${id}-${groupOption.id}`}
                    value={groupOption.id}>
                    {!optionValue
                      ? groupOption.value
                      : optionValue(groupOption)}
                  </option>
                ))}
              </optgroup>
            ) : (
              <option key={`${id}-${option.id}`} value={option.id}>
                {!optionValue ? option.value : optionValue(option)}
              </option>
            ),
          )}
        </select>
        <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
          <UnfoldIcon
            className="h-5 w-5 text-gray-300 dark:text-gray-200"
            aria-hidden="true"
          />
        </span>
      </div>
    </div>
  )
}

export default Select
